// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"e3ad5e87","712":"21fb1b6c"}[chunkId] + ".chunk.css";
};